"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextArea = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _TextArea = require("./TextArea.styled");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var TextArea = function TextArea(props) {
  var error = props.error,
      errorMessage = props.errorMessage,
      disabled = props.disabled,
      id = props.id,
      name = props.name,
      placeholder = props.placeholder,
      _onChange = props.onChange,
      _onFocus = props.onFocus,
      _onBlur = props.onBlur,
      value = props.value,
      width = props.width;
  return _react.default.createElement(_TextArea.StyledTextAreaContainer, null, _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_TextArea.StyledTextArea, {
    error: error,
    disabled: disabled,
    id: id,
    name: name,
    placeholder: placeholder,
    value: value,
    onChange: function onChange(e) {
      return _onChange(e);
    },
    onFocus: function onFocus(e) {
      return _onFocus(e);
    },
    onBlur: function onBlur(e) {
      return _onBlur(e);
    },
    width: width
  }), error && _react.default.createElement(_TextArea.StyledErrorMessage, null, errorMessage)));
};
/**
 * Definition of default values for component props
 */


exports.TextArea = TextArea;
TextArea.defaultProps = {
  id: undefined,
  name: undefined,
  placeholder: undefined,
  value: '',
  onChange: function onChange() {},
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  width: 'auto',
  error: false,
  errorMessage: undefined,
  disabled: false
};
TextArea.propTypes = {
  id: _propTypes.default.string,
  name: _propTypes.default.string.isRequired,
  placeholder: _propTypes.default.string,
  value: _propTypes.default.string,
  onChange: _propTypes.default.func,
  onFocus: _propTypes.default.func,
  onBlur: _propTypes.default.func,
  width: _propTypes.default.string,
  error: _propTypes.default.bool,
  errorMessage: _propTypes.default.string,
  disabled: _propTypes.default.bool
};